<script>
import TwTitleBar from '../components/TwTitleBar';

export default {
  components: {
    TwTitleBar,
  },
  props: ['id'],
  data() {
    return {
      confirmOpen: false,
      resolve: null,
      activeTab: `/filter/edit/${this.id}/general`,
      tabs: [
        { id: 1, name: 'General', route: `/filter/edit/${this.id}/general` },
        { id: 2, name: 'Facilities', route: `/filter/edit/${this.id}/facilities` },
      ],
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { text: 'Web content', to: '', disabled: true },
        { text: this.$t('filterList.title'), to: { name: 'FilterList' } },
        { text: this.id, to: { name: 'FilterEdit', params: { id: this.id } } },
      ];
    },
  },
};
</script>

<template>
  <div class="filter-edit">
    <tw-title-bar :title="$t('filterEdit.title')" :breadcrumbs="breadcrumbs"/>
    <v-layout fill-height row>
      <v-flex xs6>
        <v-card>
          <v-tabs class="filter-edit__tabs" v-model="activeTab" grow>
            <v-tab
              v-for="tab in tabs"
              :key="tab.id"
              :to="tab.route"
              exact>
              {{ tab.name }}
            </v-tab>
            <v-tabs-items>
              <v-tab-item
                v-for="tab of tabs"
                :transition="false"
                :reverse-transition="false"
                :key="tab.id"
                :value="tab.route">
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <router-view></router-view>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<style lang="scss">
  .filter-edit {
    &__tabs {

      .v-tabs__wrapper {
        border-bottom: 1px solid rgba(0, 0, 0, .12);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FilterEdit.vue